import { useAuditApi } from "./common/auditApi";

export function usePackageAuditApi() {
  return useAuditApi({
    url: 'package',
    translateTitle: (t) => t.audit.actions.fetchPackage.title,
    translateError: (t) => t.audit.actions.fetchPackage.error
  });
}
